import Seta from '@assets/images/Seta.svg';
import PlaceholderImage from '@assets/images/img-final-home-03.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './SectionFour.style';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const SectionFour = () => {
  const { t } = useTranslation('home');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>Brand Suitability & Brand Safety</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>{t('sectionFour.paragraphOne')}</p>
          <TextBox2>
            <p>{t('sectionFour.paragraphTwo')}</p>
            <Link to="/brandSuitability" className="link-with-icon">
              {t('sectionFour.link')}
              <div>
                <img src={Seta} alt="Saiba Mais" />
              </div>
            </Link>
          </TextBox2>
        </TextBox1>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SectionFour;
